import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { cartClient } from "@core/clients";
import { SharedCart } from "@core/types";

type SharedCartQueryKey = readonly ["shared-cart", SharedCart["id"]];

type Options = Omit<
  UseQueryOptions<SharedCart | null, Error, SharedCart | null, SharedCartQueryKey>,
  "queryKey" | "queryFn"
>;

const useSharedCartQuery = (id: SharedCart["id"], options?: Options) => {
  const { enabled: enabledFromOptions, ...rest } = options ?? {};

  return useQuery<SharedCart | null, Error, SharedCart | null, SharedCartQueryKey>(
    ["shared-cart", id] as SharedCartQueryKey,
    () => cartClient.getSharedCartById(id),
    {
      enabled: !!id,
      ...rest,
    },
  );
};

export default useSharedCartQuery;
